import { createReducer, on } from '@ngrx/store'
import { PendingState } from '../../../account/account.root.state'
import { OrderInfoActions } from '../../data/data.actions'
import { CustomerInfoActions } from '../../../account/user-profile/user-profile.actions'
import { OrderPaymentMethodActions } from '../payment-methods/payment-methods.actions'

export const orderPendingReducer = createReducer(
  PendingState.pending,
  on(OrderInfoActions.orderInfoLoad, (): PendingState => PendingState.pending),
  on(OrderInfoActions.orderInfoFail, (): PendingState => PendingState.failed),
  on(OrderInfoActions.orderInfoSuccess, (): PendingState => PendingState.success),
  on(CustomerInfoActions.c4LoginLoad, (): PendingState => PendingState.pending),
  on(OrderPaymentMethodActions.trySaveChanges, (): PendingState => PendingState.pending),
  on(OrderPaymentMethodActions.saveChangesSuccess, (): PendingState => PendingState.success),
  on(OrderPaymentMethodActions.saveChangesError, (): PendingState => PendingState.failed),
)
